<template>
    <ui-modal id="add-ticket" :title="title" title-text="Deixe-nos saber em que podemos te ajudar" size="md">
        
        <form v-on:submit.prevent="save">
            <div class="msg" v-if="message">{{message}}</div>
            <div class="input-box">
                <input id="input-title" type="text" placeholder=" " v-model="form.title" @click="message = ''">
                <label for="input-title">
                    <span>Assunto:</span>
                </label>
            </div>
            <div class="textarea-box">
                <textarea id="input-text" placeholder=" " v-textarea-resize v-model="form.text" @focus="message = ''"></textarea>
                <label for="input-text">
                    <span>Escreva sua situação:</span>
                </label>
            </div>
            <section class="input-file-box">
                <input type="file" ref="file" multiple>
            </section>
            <div class="control">
                <button type="submit" :class="indicator">Salvar </button>
            </div>
        </form>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components'
    import { tickets } from '@/services'
    import { textareaResize } from '@/directives'
    export default {
        components: { uiModal },
        directives: { textareaResize },
        props: {
            ticket: {}
        },
        data() {
            return {
                roles: [],
                message: '',
                load: false,
                title: 'Novo Chamado',
                form: {
                    id: '',
                    title: '',
                    text: '',
                },
                images: null,
            }
        },
        computed: {
            indicator(){
                return this.load ? 'load' : ''
            },
        },
        watch:{
            ticket: function(ticket){
                this.form.id = ticket.id
                this.form.title = ticket.title
                this.form.text = ticket.text
                this.title = this.ticket.id ? 'Editar Chamado' : 'Novo Chamado'
                return ticket
            }
        },
        methods: {
            save(){
                this.load = true
                if(!this.ticket.id){

                    let form = new FormData()

                    for( var i = 0; i < this.$refs.file.files.length; i++ ){
                        let file = this.$refs.file.files[i];
                        form.append('files[' + i + ']', file);
                    }

                    form.append("title", this.form.title);
                    form.append("text", this.form.text);

                    tickets.add(form).then( response => {
                        this.load = false
                        this.$root.$emit('add-item', response.data.row);
                    }, error => {
                        this.message = error.response.data.message
                        this.load = false
                    })
                }else{
                    tickets.update(this.form).then( response => {
                        this.load = false
                        response.data.row.index = this.ticket.index
                        this.$root.$emit('update-list', response.data.row);
                    }, error => {
                        this.message = error.response.data.message
                        this.load = false
                    })
                }
            },
            upload(e){
                const images    = e.target.files
                this.images     = images

                console.log(this.images)
            }
        },
        created(){
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
